"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dataCyValue = exports.dataCyPercentValue = exports.dataCyDifference = exports.dataCyCompareValue = exports.dataCy = void 0;
var dataCy = exports.dataCy = 'DataGrid-cell';
var dataCyValue = exports.dataCyValue = 'DataGrid-cell-value';
var dataCyCompareValue = exports.dataCyCompareValue = 'DataGrid-cell-compare-value';
var dataCyDifference = exports.dataCyDifference = 'DataGrid-cell-difference';
var dataCyPercentValue = exports.dataCyPercentValue = 'percentValue';